import { useRouter } from '@tanstack/react-router'
import { CircleUserRound, LogOut, Settings } from 'lucide-react'

import { ACCOUNT } from '@brickup/shared/locales/de/account'
import { Button, Menu, type MenuAction } from '@/components/base'
import { useAccountHref } from '@/hooks/use-account-href'
import { useLogout } from '@/hooks/use-logout'

/** The signed-in user's own entries: their account, and the way out. */
export function UserMenu() {
  const accountHref = useAccountHref()
  const router = useRouter()
  const signOut = useLogout()

  const actions: MenuAction[] = [
    ...(accountHref
      ? [
          {
            key: 'account',
            label: ACCOUNT.accountSettings,
            icon: Settings,
            onSelect: () => router.navigate({ href: accountHref }),
          },
        ]
      : []),
    {
      key: 'logout',
      label: ACCOUNT.logout,
      icon: LogOut,
      onSelect: signOut,
    },
  ]

  return (
    <Menu
      actions={actions}
      label={ACCOUNT.accountSettings}
      trigger={
        <Button
          variant="ghost"
          size="icon"
          aria-label={ACCOUNT.accountSettings}
          icon={CircleUserRound}
        />
      }
    />
  )
}
